import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import css from '../assets/css.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import react from '../assets/react.png';
import sass from '../assets/sass.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import blob from "../assets/overlay_blob.svg"

export default {
    email,
    mobile,
    css,
    html,
    javascript,
    react,
    sass,
    profile,
    circle,
    blob,
};